import { Component, Input, Output, EventEmitter, Optional} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PartListHistoryDialog } from '../../PartListHistory/PartListHistoryDialog';
import { DMApiService } from 'src/app/API/dmapi.service';
import { AppComponent } from 'src/app/app.component';
import { Globals } from 'src/app/globals';
@Component({
  selector: 'PartListHistoryComponent',
  templateUrl: './PartListHistoryComponent.html',
})
export class PartListHistoryComponent {
  @Input() EquipId!: string;
  @Input() EquipDesc!: string;
  @Input() AvailableQuantity!: string;
  @Input() MachineName!: string;
  @Input() DivisionId!: string;
  public detailsType = "Dialysis Machines";
  title="Part List History Report";
  
  constructor(
  @Optional() public dialogRef: MatDialogRef<PartListHistoryDialog>,
  private dmapi: DMApiService,
  public dialog: MatDialog
) {
    this.page.pageNumber = 0;
    this.page.size = 25;
  }
 
  PartsHistoryData=[];
    page = new Page();
    rows ;
    pageSize = 50;
    currentPageNumber = 1;
    isPageLoaded =false;

  ngOnInit()
  {
     console.log('PartListHistoryComponent data:', {
      EquipId: this.EquipId,
      EquipDesc: this.EquipDesc,
      AvailableQuantity: this.AvailableQuantity,
      MachineName: this.MachineName,
      DivisionId: this.DivisionId
    });
    this.ShowPartsHistory();
  }

  totalUsedQuantity=0;

  ShowPartsHistory()
  {
    var equipObj = {Id:this.EquipId};
    this.title="Part History";
    AppComponent.ShowLoader();
    this.dmapi.GetPartsHistoryByPartID(equipObj).subscribe(list =>
      {
        this.totalUsedQuantity=0;
        this.PartsHistoryData = this.DivisionId ? list.filter(item => item.divisionId == this.DivisionId): list;
         for (let childObj in this.PartsHistoryData) {
          const totalQuantity = this.PartsHistoryData[childObj].quantity;
          if (totalQuantity != null && totalQuantity != undefined) {
            this.totalUsedQuantity += totalQuantity;  
          }
        }
        AppComponent.HideLoader();
      },
      error=>
      {
        AppComponent.addAlert(error.message,"error");
        AppComponent.HideLoader();
      }
    );
  }

  get random() {
    return Math.floor(Math.random() * 1000) + 1;
  }

  alertmessage = '';

  addAlert(message, typeP) {

    let timeoutSeconds = parseInt(Globals.defaultTimeForAlert);

    if(typeP == "error" && message != Globals.FormErrorMessage)
      timeoutSeconds = parseInt(Globals.defaultTimeForErrorAlert);

    const _success = {msg: message, type: typeP, successMessage: true};
    setTimeout(() => _success.successMessage = null, timeoutSeconds);
    this.alertmessage = message;

    setTimeout(() =>{
      let errorText = document.querySelectorAll('ngb-alert div span')
      try {
        this.alertmessage = '';
        errorText[errorText.length - 1].innerHTML ='OK';
      } catch (error) {

      }

    },50);
  }

  setlinkMachine(formtype:string, remark:string, transid :string, divisionName : string)
    {
        var href = '';
        try
        {
            switch (formtype)
            {
                case "Incident":
                    this.dmapi.PrintIncidentPDF({ Id: transid }).subscribe((blob: any) => {
                      const file = new Blob([blob], { type: 'application/pdf' });
                      const fileURL = URL.createObjectURL(file);
                      window.open(fileURL);
                    }, error => {
                      AppComponent.addAlert(error.message, 'error');
                      AppComponent.HideLoader();
                    });
                    break;
                case "Filter Change":
                    this.dmapi.PrintFilterPDF({ Id: transid }).subscribe((blob: any) => {
                      const file = new Blob([blob], { type: 'application/pdf' });
                      const fileURL = URL.createObjectURL(file);
                      window.open(fileURL);
                    }, error => {
                      AppComponent.addAlert(error.message, 'error');
                      AppComponent.HideLoader();
                    });
                    break;
                case "dmrepair":
                    this.dmapi.PrintRepairPDF({ Id: transid, str : this.detailsType }).subscribe((blob: any) => {
                      const file = new Blob([blob], { type: 'application/pdf' });
                      const fileURL = URL.createObjectURL(file);
                      window.open(fileURL);
                    }, error => {
                      AppComponent.addAlert(error.message, 'error');
                      AppComponent.HideLoader();
                    });
                    break;
                case "other":
                    this.dmapi.PrintRepairPDF({ Id: transid, str : 'Other Equipment' }).subscribe((blob: any) => {
                      const file = new Blob([blob], { type: 'application/pdf' });
                      const fileURL = URL.createObjectURL(file);
                      window.open(fileURL);
                    }, error => {
                      AppComponent.addAlert(error.message, 'error');
                      AppComponent.HideLoader();
                    });
                    break;
                case "PreventiveMaintenance":
                    this.dmapi.PrintPreventivePDF({ Id: transid }).subscribe((blob: any) => {
                      const file = new Blob([blob], { type: 'application/pdf' });
                      const fileURL = URL.createObjectURL(file);
                      window.open(fileURL);
                    }, error => {
                      AppComponent.addAlert(error.message, 'error');
                      AppComponent.HideLoader();
                    });
                    break;
                default:
                    if (remark.startsWith("Work Order~"))
                    {
                       href = Globals.oldUrl + "/exportFiles/" + remark.substring(11);
                    }
                    else
                        href = '';
                    break;
            }
        }
        catch{}
        return href;
    }
 
    setPage() {
      this.currentPageNumber=this.page.pageNumber;
    }
}

export class Page {
    //The number of elements in the page
    size: number = 50;
    //The total number of elements
    totalElements: number = 0;
    //The total number of pages
    totalPages: number = 0;
    //The current page number
    pageNumber: number = 0;
  }

